import BaseSelect from 'components/Selects/BaseSelect/BaseSelect';
import {
  findSelectOption,
  findSelectOptions,
} from 'components/Selects/BaseSelect/utils/baseSelect.utils';
import IpawsFieldFindings, {
  getIpawsFieldFindingDescriptionId,
} from '../IpawsFieldFindings/IpawsFieldFindings';

const alertCreatorSelectClassNames = {
  control: () => 'alert-creator-select-control',
};

const IpawsSelectField = ({
  inputId,
  fieldPath,
  label,
  options,
  selectedOptions = options,
  value,
  onChange,
  findings = [],
  required = false,
  isMulti = false,
  isSearchable,
  isClearable = false,
  isOptionDisabled,
  formatOptionLabel,
  placeholder,
  wrapperClassName = 'alert-creator-select w-100',
}) => {
  const findingDescriptionId = getIpawsFieldFindingDescriptionId(fieldPath, findings);
  const hasFinding = Boolean(findingDescriptionId);

  return (
    <div className="d-flex flex-column gap-1">
      <BaseSelect
        inputId={inputId}
        wrapperClassName={wrapperClassName}
        label={label}
        classNames={alertCreatorSelectClassNames}
        isMulti={isMulti}
        isSearchable={isSearchable}
        isClearable={isClearable}
        selectProps={{
          name: fieldPath,
          options,
          value: isMulti
            ? findSelectOptions(selectedOptions, value)
            : findSelectOption(selectedOptions, value),
          placeholder,
          onChange,
          isOptionDisabled,
          formatOptionLabel,
          ...(required ? { required: true, 'aria-required': true } : {}),
          'aria-invalid': hasFinding,
          'aria-errormessage': findingDescriptionId,
          'aria-describedby': findingDescriptionId,
        }}
      />
      <IpawsFieldFindings fieldPath={fieldPath} findings={findings} />
    </div>
  );
};

export default IpawsSelectField;
